export default "__VITE_PUBLIC_ASSET__fab882f0__"